import { BOLD } from '@lumapps/wrex-typography/constants';
import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';

import { T_H } from '../constants';
import type { HeaderType, THElement } from '../types';

/**
 * Create a TH (table header cell) element. Defaults to a column header (`scope="col"`).
 * An empty header cell starts bold so that header text is emphasized as soon as it is typed.
 */
export const createTH = (
    children: THElement['children'] = [createParagraph([{ text: '', [BOLD]: true }])],
    headerType: HeaderType = 'col',
): THElement => ({ type: T_H, headerType, children });
